import { useSelector, useDispatch } from 'react-redux';
import { hideLoginModal } from '../../reducers/loginModal';
import Modal from '../modal';
import { Formik } from 'formik';
import { Button } from '../button';
import { Input } from '../input';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';
import { StyledForgotPassword } from './style';

const LoginModal = (props) => {
  const dispatch = useDispatch();
  const loginModalReducer = useSelector((state) => state.loginModal);

  if(loginModalReducer.show){
    const initialValues = {
      user: {
        email: loginModalReducer.user.email,
        password: '',
      }
    }

    const handleCloseClick = () => {
      dispatch(hideLoginModal());
    }

    const validate = (values) => {
      const errors = { user: {} };
      const user = values.user;

      if (!user.email){
        errors.user.email = 'Digite o seu email';
      }

      if (!user.password){
        errors.user.password = 'Digite a sua senha';
      }

      return errors;
    }

    return (
      <Modal onCloseClick={handleCloseClick}>
      <Formik
        initialValues={initialValues}
        validate={validate}
      >
        <form action={`${process.env.REACT_APP_API_BASE_URL}/login`} method="post">
          <PageHeader>
            <h1>Opa! Te encontramos{loginModalReducer.user.firstName ? `, ${loginModalReducer.user.firstName}` : ''}!</h1>
            <p>Faça o seu login para continuar criando o seu pedido.</p>
          </PageHeader>

          <Input name="user[email]" label="Email" type="email" autoComplete="username" />
          <Input name="user[password]" label="Senha" type="password" autoComplete="current-password" />

          <StyledForgotPassword>
            <a href={`${process.env.REACT_APP_API_BASE_URL}/password/new`} target="_blank" rel="noreferrer">Esqueci minha senha</a>
          </StyledForgotPassword>

          <FormActions>
            <Button type="submit" buttonStyle="full">
              Entrar
            </Button>
          </FormActions>
        </form>
      </Formik>
      </Modal>
    )
  }
  else return null;
}

export default LoginModal;
